itsoftApp.createModule("subMenu", function () {
    const menuWrapper = document.querySelector(".js-menu-wrapper");
    const menuLinks = document.querySelectorAll(".js-sub-menu-trigger");
    const overlay = document.querySelector(".js-menu-overlay");

    const activateSubMenu = function () {
        menuWrapper.classList.add("js-active-submenu");
    };

    const deactivateSubMenu = function () {
        menuWrapper.classList.remove("js-active-submenu");
    };

    if (menuLinks.length > 0) {
        overlay.addEventListener("mouseleave", function () {
            deactivateSubMenu();
        });
        
        Array.prototype.forEach.call(menuLinks, function (link) {
            link.addEventListener("mouseenter", function () {
                activateSubMenu();
            });

            link.addEventListener("mouseleave", function (evt) {
                if (evt.relatedTarget != overlay) {
                    deactivateSubMenu();
                }
            });
        });
    }

    const mainMenuLinks = document.querySelectorAll(".js-main-link");

    if (mainMenuLinks.length) {
        Array.prototype.forEach.call(mainMenuLinks, function (el) {
            el.addEventListener("click", function (evt) {
                if (itsoftApp.utils.getViewportSize() < 1280 && itsoftApp.utils.isTouchDevice()) {
                    evt.preventDefault();
                }
            });
        });
    }
});